import React, { useState, useEffect } from 'react';
import MainLayout from './mainLayout';
import PointerItem from '../components/pointerItem';
import { useData } from '../hooks/useContext';
import Pagination from '../components/pagination';
import { paginate } from '../utils/paginate';
import Loader from '../components/loader';
import { IPartialOrganization, IUseData } from '../interfaces';
import PageCard from '../components/pageCard';
import Search2 from '../components/search2';
import organizationsService from '../services/organizations.service';
import { CONFIG } from '../config';

const OrganizationsList = () => {
  const { setPage, organizations, theme } = useData() as IUseData;
  const [paginationPage, setPaginationPage] = useState<number>(1);
  const [filteredOrganizations, setFilteredOrganizations] = useState<IPartialOrganization[]>([]);

  const pageSize: number = 16;

  useEffect(() => {
    setPage('organizations');
    document.title = CONFIG.PAGES_CARDS.ORGANIZATIONS_PAGE.HEADER;
  }, []);

  useEffect(() => {
    setFilteredOrganizations(organizations);
  }, [organizations]);

  const handleSearchResult = (data: any) => {
    console.log('OrganizationsList.handleSearchResult()', data);

    if (data == null) {
      setFilteredOrganizations(organizations);
    } else {
      let newOrgs: IPartialOrganization[] = [];
      organizations.forEach((org: IPartialOrganization) => {
        if (data.includes(org._id)) {
          newOrgs.push(org);
        }
      });
      setFilteredOrganizations(newOrgs);
    }
  };

  return (
    <MainLayout>
      {/* <div className="m-auto w-full 2xl:w-4/5 h-100 md:px-12 flex flex-col px-2"> */}
      <PageCard />
      {CONFIG.SHOW_SEARCH2 ? (
        <Search2 onResult={handleSearchResult} searchFunction={organizationsService.search2} />
      ) : null}
      <main className={'grow flex flex-col rounded-[40px] p-[40px] my-5' + theme.active}>
        {filteredOrganizations ? (
          <>
            <h2 className={'text-2xl font-medium mb-2 border-b-2' + theme.redBorder} autoFocus={true}>
              {'Организации (' + filteredOrganizations.length + ')'}
            </h2>
            <ul>
              {paginate<IPartialOrganization>(filteredOrganizations, paginationPage, pageSize).map(
                (item: IPartialOrganization) => (
                  <PointerItem
                    key={item._id}
                    name={item.name}
                    link={'organizations/' + item._id}
                    num={filteredOrganizations.indexOf(item) + 1}
                    subnames={item.subnames}
                  />
                )
              )}
            </ul>
            <Pagination
              productCount={filteredOrganizations.length}
              pageSize={pageSize}
              currentPage={paginationPage}
              onPageChange={(page: number) => setPaginationPage(page)}
            />
          </>
        ) : (
          <Loader title={'Загрузка списка организаций...'} />
        )}
      </main>
      {/* </div> */}
    </MainLayout>
  );
};

export default OrganizationsList;
